<template>
  <div id="app">
  	<loading v-if="guodu"></loading>
  	<v-header></v-header>
    <v-nav></v-nav>
    <router-view></router-view>
    <v-playdown></v-playdown>
    <v-bigplay></v-bigplay>
  </div>
</template>

<script>
import header from './components/header.vue'
import nav from './components/nav.vue'
import playDown from './components/playDown.vue'
import loading from './components/loading.vue'
import bigPlay from './components/bigPlay.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      
    }
  },
  computed: {
    	...mapGetters(['guodu'])
  },
  components:{
  	'v-header':header,
  	'v-nav':nav,
  	'v-playdown':playDown,
  	loading:loading,
  	'v-bigplay':bigPlay,
  },
  created: function () {
      this.$router.push({path: '/index'})
  },
}
</script>

<style>
#app{width: 100%;height: 100%;}
</style>



// WEBPACK FOOTER //
// App.vue?12b9ca0d